import { setText, toggleClass, isNumeric } from '../helpers/attribute-helper';

export default class PriceManager {
    constructor(parent) {
        this.parent = parent;
        this.el = parent.el;
        this.client = parent.client;
        this.data = parent.data;
        this.car = parent.car;
        this.pricing = parent.pricing;
        this.promotionsHelper = parent.promotionsHelper;
        this.provider = parent.financeProvider;
    }

    async update() {
        await this.pricing.waitForMTOPricing();

        this.updateMTOPricing();
        this.updateColourPricing();
        this.updateTrimPricing();
        this.updateAccessoryPricing();
        this.updateWheelPricing();
        this.updateAdditionalProductPricing();

        await this.pricing.getMTOCEPricing();
        if(!this.pricing.hasPricing()) { return; }

        this.updateCarPricing();

        if (this.provider === 'CALMS') {
          this.parent.navigation.hideLoader();
        }
    }

    updateMTOPricing() {
      const mtoPrices = this.pricing.getMTOPrices({ discountPrice: false });
      setText(this.el, mtoPrices, 'data-mto-price', (val, el) => this.pricing.format(val, false, el));
      toggleClass(this.el, mtoPrices, 'data-mto-price-toggle', 'hide', false, isNumeric);
    }

    updateColourPricing() {
      const colourPrices = this.pricing.getColourPrices();
      setText(this.el, colourPrices, 'data-colour-price', (val, el) => this.pricing.format(val, false, el));
      const carColourPrice = colourPrices[this.car.colourTrim().colourMTOCE];
      setText(this.el, carColourPrice, 'data-car-colour-price', (val, el) => this.pricing.format(val, false, el));
    }

    updateTrimPricing() {
      const trimPrices = this.pricing.getTrimPrices();
      setText(this.el, trimPrices, 'data-trim-price', (val, el) => this.pricing.format(val, false, el));
      const carTrimPrice = trimPrices[this.car.colourTrim().trimMTOCE];
      setText(this.el, carTrimPrice, 'data-car-trim-price', (val, el) => this.pricing.format(val, false, el));
    }

    updateColourTrimPricing() {
      const colourTrimPrices = this.pricing.getColourTrimPrices({ discountPrice: false });
      setText(this.el, colourTrimPrices, 'data-colour-trim-price', (val, el) => this.pricing.format(val, false, el));
      const carColourTrimPrice = colourTrimPrices[this.car.colourTrim().trimMTOCE];
      setText(this.el, carColourTrimPrice, 'data-car-colour-trim-price', (val, el) => this.pricing.format(val, false, el));
    }

    updateAccessoryPricing() {
      const accessoryPrices = this.pricing.getAccessoryPrices({ discountPrice: false });
      setText(this.el, accessoryPrices, 'data-accessory-price', (val, el) => this.pricing.format(val, false, el));
    }

    updateWheelPricing() {
      const carWheelPrice = this.pricing.getWheelPrices({ discountPrice: false })?.[this.car.wheelMTOCE()];
      setText(this.el, carWheelPrice, 'data-car-wheel-price', (val, el) => this.pricing.format(val, false, el));
    }

    updateAdditionalProductPricing() {
      const additionalProductPrices = this.pricing.getAdditionalProductPricesMTO({ discountPrice: false });
      setText(this.el, additionalProductPrices, 'data-additional-product-price', (val, el) => this.pricing.format(val, false, el));
    }

    updateCarPricing() {
      setText(this.el, this.pricing.getCarBasePrice(), 'data-car-base-price', (val, el) => this.pricing.format(val, false, el));

      const carTotalPrice = this.pricing.getCarTotalPrice({ discountPrice: false });
      setText(this.el, carTotalPrice, 'data-car-total-price', (val, el) => this.pricing.format(val, false, el));

      const carAccessoriesPrice = this.pricing.getCarAccessoriesPrice({ discountPrice: false });
      setText(this.el, carAccessoriesPrice, 'data-car-accessories-price', (val, el) => this.pricing.format(val, false, el));
    }
}